export default "__VITE_ASSET__qdMJ8LKW__"